<template>
  <el-dialog
    title="添加成员"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    :visible.sync="show"
    width="40%"
  >
    <form class="form-horizontal">
      <div class="form-group options_box">
        <div class="col-sm-12">
          <tree-common ref="treeCommon" :treeData="allTeachers"></tree-common>
        </div>
      </div>
    </form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="mini">取 消</el-button>
      <el-button type="primary" @click="addDataAction()" size="mini"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import TreeCommon from "@/components/TreeCommon";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    TreeCommon
  },
  props: {
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    roleId: {
      type: String
    }
  },
  data() {
    //这里存放数据
    return {
      show: false,
      allTeachers: []
    };
  },
  //监控data中的数据变化
  watch: {
    showDialog: function(val) {
      this.show = val;
      if (val) {
        this.getUserDataList();
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    // 获取数据列表
    async getUserDataList() {
      let req = {
        pageSize: 10000,
        pageNum: 1,
        schoolId: parseInt(this.$store.state.schoolId),
        departmentId: "",
        userPhone: "",
        userName: ""
      };
      let res = await this.$Http.getTeacherList(req, true);
      if (res.code == 200) {
        if (res.data) {
          let data = res.data.list || [];
          let newData = data.map((item) => {
            let obj = {
              label: item.Name || "",
              id: item.id || "",
              leve: "2"
            };
            return obj;
          });
          if (data.length > 0) {
            this.allTeachers = [
              {
                label: "全部",
                id: "00",
                leve: "1",
                children: newData
              }
            ];
          }
        } else {
          this.allTeachers = [];
        }
      } else if (res.code == 101) {
        this.allTeachers = [];
      } else {
        this.allTeachers = [];
        this.$message({
          type: "error",
          message: res.messsage || ""
        });
      }
    },
    async addDataAction() {
      let userList = this.$refs.treeCommon.$refs.tree.getCheckedKeys();
      if (userList.length > 0) {
        let req = userList.map((item) => {
          let obj = {
            roleId: this.roleId,
            userId: item
          };
          return obj;
        });
        let res = await this.$Http.addRoleMember(req);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "添加成功"
          });
      this.$emit("close");
        } else if (res.code == 101) {
        } else {
          this.$message({
            type: "error",
            message: res.messsage
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请先选择您要添加的成员"
        });
        return false;
      }
    },
    handleClose() {
      this.$emit("close");
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss"></style>
